import React from 'react';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import Zone, { ZoneGroup } from '../../Layout/Zone';
import { ZoneType } from '../../../../types/layout';
import { ModuleType } from '../../../../types/modules';
import AdoptabobblesBoughtBox from '../../UserWidgets/AdoptabobblesBought';
import StreamPagination from '../_partials/StreamPagination';

import s from './AdoptabobblesSection.scss';

export interface Props {
  isSectionLoading: boolean;
  isOwner: boolean;
  isWatching: boolean;
  isEmpty: boolean;
  streamId: string;
}

export interface RouteParams {
  username: string;
}

const AdoptabobblesSection: React.FC<Props & RouteParams> = ({
  isSectionLoading,
  streamId,
}) => {
  if (isSectionLoading) {
    return <LoadingIndicator />;
  }

  return (
    <div className={s['root']}>
      <ZoneGroup
        className={s['zone-group']}
        disableTopAddWidget
      >
        <Zone
          className={s['zone']}
          locked={true}
          type={ZoneType.MID_RIGHT}
          mapModuleTypeToWidgetComponent={{
            [ModuleType.ADOPTABOBBLES_BOUGHT]: AdoptabobblesBoughtBox,
          }}
        />
      </ZoneGroup>
      <StreamPagination streamId={streamId} />
    </div>
  );
};
AdoptabobblesSection.displayName = 'AdoptabobblesSection';

export default AdoptabobblesSection;
